import { isSSR as d } from "./isSSR.js";
import { isString as n } from "lodash";
const w = () => {
    var o;
    typeof ((o = window == null ? void 0 : window._mfq) == null ? void 0 : o.push) != "function" && (window._mfq = []);
  },
  l = o => {
    var i;
    w(), (i = window == null ? void 0 : window._mfq) == null || i.push(o);
  },
  t = o => {
    d() || !n(o) || l(["tag", o]);
  },
  a = (o, i) => {
    d() || !n(o) || !n(i) || l(["setVariable", o, i]);
  };
export { t as addMouseflowTag, a as addMouseflowVariable };